
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.25.065a.624.624 0 100 1.25h1.615L3.934 5.249a.626.626 0 00.884.884L8.75 2.2v1.615a.624.624 0 101.25 0V.69a.624.624 0 00-.625-.625H6.25zM1.562.69C.7.69 0 1.39 0 2.252v6.25c0 .864.7 1.563 1.563 1.563h6.25c.863 0 1.562-.7 1.562-1.563V6.315a.624.624 0 10-1.25 0v2.187c0 .172-.14.313-.313.313h-6.25a.313.313 0 01-.312-.313v-6.25c0-.171.14-.312.313-.312H3.75a.624.624 0 100-1.25H1.562z","fill":"#0078E6"}})])
          )
        }
      }
    